<template>
    <div class="body-list">
        <div class="none-array" v-show="clockArray.length === 0 && clockedArray.length === 0">
            <img class="img-list-none" src="../../../../assets/images/List/img-list-none.png" alt="">
            <div class="text-list-none">暂无数据</div>
        </div>
        <MatterGroup :groupMatters="clockArray"
                     @operateEvent="submitOperate($event)"
                     @clockEvent="submitClock($event)"
                     @matterEvent="submitMatter($event)"
                     @toDayEvent="submitToDay($event)"
                     @setDateEvent="submitSetDate($event)"
        />
        <div class="text-tip-clock" v-show="clockedArray.length > 0">已打卡</div>
        <MatterGroup :groupMatters="clockedArray"
                     @operateEvent="submitOperate($event)"
                     @clockEvent="submitClock($event)"
                     @matterEvent="submitMatter($event)"
                     @toDayEvent="submitToDay($event)"
                     @setDateEvent="submitSetDate($event)" />

    </div>
</template>

<script>
import MatterGroup from "./MatterGroup";
import {mapState} from "vuex";
export default {
    name: "MatterList",
    components: {
        MatterGroup
    },
    data(){
        return {
            clockArray: [],
            clockedArray: [],
        }
    },
    computed: {
        ...mapState("listModules", {
            categoryShowId: state => state.categoryShowId,
        })
    },
    props:{
        matterArray: {
            type: Array,
            default: ()=> [],
        },
        waitState: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        setClockArray: function(){
            const clockArray = [];
            const clockedArray = [];
            this.matterArray.forEach((item)=>{
                // 是否展示待办

                if(this.waitState !== item.info.isWaiting){
                    return
                }else if(this.categoryShowId !== "all" && this.categoryShowId !== item.info.categoryId){
                    return
                }
                if(item.timeInfo.state <= 0){
                    // 未打卡
                    clockArray.push(item);
                }else{
                    // 已打卡
                    clockedArray.push(item);
                }
            })
            this.clockArray = clockArray;
            this.clockedArray = clockedArray;
        },
        submitOperate: function(e){

            this.$emit("operateEvent", e);
        },
        submitClock: function(e){
            this.$emit("clockEvent", e)
        },
        submitMatter: function(e){
            this.$emit("matterEvent", e)
        },
        submitToDay: function(e){
            this.$emit("toDayEvent", e)
        },
        submitSetDate: function(e){
            this.$emit("setDateEvent", e)
        },
    },
}
</script>

<style scoped>
div.body-list {
    width: 100%;
    height: calc(100% - 0.56rem);
    box-sizing: border-box;
    padding: 0.2rem 0.5rem 0.3rem;
    position: relative;
}

div.text-tip-clock{
    width: 100%;
    height: 0.22rem;
    margin-top: 0.3rem;
    margin-bottom: 0.2rem;

    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.2rem;
    text-align: left;
    text-indent: 0.05rem;

    background-image: url("../../../../assets/images/List/icon-tip-clock.png");
    background-position: left bottom;
    background-repeat: no-repeat;
    background-size: 0.58rem 0.07rem;
}
img.img-list-none{
    width: 1.55rem;
    height: 2.14rem;
    display: block;
    margin: 2.67rem auto auto;
}
div.text-list-none{
    font-size: 0.15rem;
    color: #666666;
    line-height: 0.21rem;
    text-align: center;
    margin-top: 0.13rem;
}
</style>